
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import MainLayout from '../components/layout/MainLayout';
import useTranslation from "next-translate/useTranslation";
import Footer from "../components/layout/Footer";
import Navigation from "../components/layout/Navigation";
import Accordion from "../components/Accordion";
import Loader from "../components/Loader";
export default function Faqs() {
    const { t } = useTranslation();
    const seo = t('common:seo', {}, { returnObjects: true });
    const faqs = t('faqs:data', {}, { returnObjects: true });
    const [isLoading, setIsLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "name": "HFDX FAQ - Frequently Asked Questions",
        "mainEntity": faqs?.list?.map(el => {
            return {
                "@type": "Question", "name": el.title, "acceptedAnswer": {
                    "@type": "Answer", "text": el.text.join(' ')
                }
            };
        })
    };
    useEffect(() => {
        let appLoading = new Promise((resolve) => {
            setTimeout(resolve, 500, true);
        });
        Promise.all([appLoading]).then(() => {
            setIsLoading(false);
            setLoaded(true);
        });
    }, []);
    return (<MainLayout loaded={loaded} title={seo.faqs.title} description={seo.faqs.description} keywords={seo.faqs.keywords} page={'faqs'} alternate={'faqs'} canonical={'/faqs'} schemaData={schemaData}>
            <Navigation />
            <main className='main' style={{ overflowX: 'hidden' }}>
                <section className={'faqs_banner'}>
                    <div className="container">
                        <div className="faqs_banner_wrapper">
                            <h1>{faqs.title}</h1>
                            <p>{faqs.description}</p>
                        </div>
                    </div>
                </section>
                <section className={'faqs_data'} id={'faqs'}>
                    <div className="container">
                        <div className="faqs_wrapper">
                            <div className={'faqs_list'}>
                                <Accordion items={faqs.list}/>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer t={t}/>
            <Loader isLoading={isLoading} loaded={loaded}/>
        </MainLayout>);
}

    async function __Next_Translate__getStaticProps__1a17ab3f1d8__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/faqs',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f1d8__ as getStaticProps }
  